import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class ExpiryHelper {
  private dateFormat: string = "DD-MMM-YYYY";
  constructor() {}

  retrieveData(order: any, columnProperty: string): string {
    if (order[columnProperty]) {
      let tmAls: string = order[columnProperty].timeAlias;
      if (tmAls != undefined && tmAls === "DAY") return "DAY";
      return this.formatDateAndTime(order, columnProperty);
    }
    return "GTC";
  }

  private formatDateAndTime(order: any, columnProperty: string): string {
    let expDate: string = order[columnProperty].expiryDate;
    let expTime: string = order[columnProperty].expiryTime;
    let timezone: string = order[columnProperty].timezone;
    if (expTime != undefined && expTime.length == 4) {
      expTime = expTime.substr(0, 2) + ":" + expTime.substr(2, 2);
    }
    if (expDate && expTime)
      return (
        CubiqTS.moment(expDate, "YYYY-MM-DD").format(this.dateFormat) +
        " " +
        expTime +
        " " +
        timezone
      );
    return "-";
  }
}
